/*******************************************************************************
 * Project：
 * Summary:
 *　　 Define Jwt interceptor
 * Remarks:
 *
 * History：
 *      NghiaNX            2021/04/28    Create
 ******************************************************************************/
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { NEVER, Observable } from 'rxjs';
import { Utility } from '../../shared/utility/utility';
import { AppConfigService } from '../../helpers/app-init-config.service';
import { EndpointsConfig } from 'src/app/config/endpoints.config';
import { AuthenticationService } from '../service/authentication.service';
@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    private lastTime: Date;
    constructor(private util: Utility, private authen: AuthenticationService) { }
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!/^(http|https|):/i.test(request.url) && !request.url.startsWith('./assets')
            && !request.url.startsWith('/assets/i18n')) {
            request = request.clone({
                url: AppConfigService.settings.apiUrl + request.url,
            });
        }
        if (this.util.isNullOrEmpty(localStorage.lastTime)) {
            localStorage.lastTime = JSON.stringify(new Date());
            this.lastTime = new Date();
        } else {
            this.lastTime = JSON.parse(localStorage.lastTime);
        }
        // if (request.url.indexOf(EndpointsConfig.infoMessage.messageUnread) === -1) {
        //     if (this.util.isNullOrEmpty(this.lastTime)) {
        //         this.lastTime = new Date();
        //     } else {
        //         const sec = this.util.checkTimeLifeApi(this.lastTime);
        //         if (sec > AppConfigService.settings.TimeOutAPI) {
        //             this.lastTime = null;
        //             this.authen.logout();
        //             return NEVER;
        //         } else {
        //             localStorage.lastTime = JSON.stringify(new Date());
        //         }
        //     }
        // }
        request = request.clone({ setHeaders: { 'Content-Type': 'application/json'} });
        if (!this.util.isNullOrBlank(sessionStorage.token)) {
            const token = JSON.parse(sessionStorage.token);
            request = request.clone({ setHeaders: { Authorization: 'Bearer ' + token } });
        }
        return next.handle(request);
    }

}
